// extracted by mini-css-extract-plugin
export var wordContainer = "_pf-0";